import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { translations } from './locales';

/**
 * Language resolution policy:
 * 1. An explicit user choice (made via LanguageSelectDialog, persisted
 *    under the `userLanguage` localStorage key) always wins.
 * 2. Otherwise the browser language (navigator) is used on every visit.
 * 3. Unsupported browser languages fall back to German.
 *
 * `caches` is intentionally empty: the detector must NOT auto-persist the
 * navigator-detected language, otherwise the first visit would freeze the
 * language forever and later browser-language changes would be ignored.
 * Only LanguageSelectDialog writes the `userLanguage` key.
 *
 * `supportedLngs` + `load: 'languageOnly'` normalize regional codes
 * (e.g. en-US, de-CH) to plain 'en'/'de', so `i18n.language` can safely
 * be compared against those values.
 */
const DETECTION_OPTIONS = {
  order: ['localStorage', 'navigator'],
  lookupLocalStorage: 'userLanguage',
  caches: [],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    detection: DETECTION_OPTIONS,
    resources: translations,
    supportedLngs: ['de', 'en'],
    load: 'languageOnly',
    fallbackLng: 'de',
    debug: false,
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'i', 'em', 'p', 'span'],
    },
  });

// Keep <html lang> in sync for accessibility and browser translation
// features (index.html hardcodes "en" as the initial value).
i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});
if (i18n.resolvedLanguage) {
  document.documentElement.lang = i18n.resolvedLanguage;
}

export default i18n;
